module.exports = __webpack_public_path__ + "static/media/singedani-handbag.8c514601.jpg";